import React, { useContext } from "react";
import { OrderContext } from "../../OrderContext.tsx";
import { AddressStatus, Address as AddressType, Order, ValidationErrors, } from "../../types.ts";
import Address from "./Address.tsx";

interface AddressFormProps {
  type: 'invoice' | 'location';
  validationErrors?: ValidationErrors;
  disableAddressCheck?: boolean;
}

function AddressForm({ type, validationErrors, disableAddressCheck }: AddressFormProps) {
  const { formValues, setFormValues } = useContext(OrderContext);

  const street = `${type}-street` as keyof Order;
  const house = `${type}-house` as keyof Order;
  const stairway = `${type}-stairway` as keyof Order;
  const flat = `${type}-flat` as keyof Order;
  const postalcode = `${type}-postalcode` as keyof Order;
  const city = `${type}-city` as keyof Order;
  const careof = `${type}-careof` as keyof Order;
  const status = `${type}-status` as keyof Order;

  const zipCode = formValues[postalcode] as string ?? '';
  const cityName = formValues[city] as string ?? '';
  const streetName = formValues[street] as string ?? '';
  const houseNumber = formValues[house] as string ?? '';
  const houseLetter = formValues[stairway] as string ?? '';
  const residence = formValues[flat] as string ?? '';
  const careOf = formValues[careof] as string ?? '';
  const addressStatus = formValues[status] as AddressStatus;

  const update = (address?: Partial<AddressType>, statusValue?: AddressStatus) => {

    const newValues = {
      [street]: address?.streetName ?? streetName,
      [house]: address?.houseNumber ?? houseNumber,
      [stairway]: address?.houseLetter ?? houseLetter,
      [flat]: address?.residence ?? residence,
      [postalcode]: address?.zipCode ?? zipCode,
      [city]: address?.cityName ?? cityName,
      [careof]: address?.careOf ?? careOf,
      [status]: statusValue, // reset status every time other fields are updated
    }
    const updatedOrder = {
      ...formValues,
      ...newValues,
    };
    setFormValues(updatedOrder);
  }

  const zipCodeError = validationErrors && validationErrors[postalcode]
  const cityNameError = validationErrors && validationErrors[city]
  const streetNameError = validationErrors && validationErrors[street]
  const houseNumberError = validationErrors && validationErrors[house]
  const houseLetterError = validationErrors && validationErrors[stairway]
  const residenceError = validationErrors && validationErrors[flat]
  const addressStatusError = validationErrors && validationErrors[status]

  return (
    <Address
      zipCode={zipCode}
      cityName={cityName}
      streetName={streetName}
      houseNumber={houseNumber}
      houseLetter={houseLetter}
      residence={residence}
      onUpdate={update}
      zipCodeError={zipCodeError}
      cityNameError={cityNameError}
      streetNameError={streetNameError}
      houseNumberError={houseNumberError}
      houseLetterError={houseLetterError}
      residenceError={residenceError}
      careOf={careOf}
      disableAddressCheck={disableAddressCheck}
      status={addressStatus}
      statusError={addressStatusError}
    />
  );
}
export default AddressForm;
